export default "__VITE_ASSET__d08af5a3__"